"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../utils/styled"));
exports.Svg = styled_1.default.svg `
  min-height: ${({ size = 18 }) => size}px;
  min-width: ${({ size = 18 }) => size}px;
  /* otherwise corners of icon cut out */
  overflow: visible;
  margin-left: ${({ right, theme }) => (right ? theme.space.small : 0)}px;
  margin-right: ${({ left, theme }) => (left ? theme.space.small : 0)}px;

  > * {
    pointer-events: none;
  }

  ${({ onClick, theme }) => onClick
    ? `
    padding: ${theme.space.base}px;
    cursor: pointer;
    outline: none;
    :hover, :focus, .no-focus &:hover:focus {
      background: ${theme.color.background.light};
      /* we need to set it here, because otherwise icon takes shape of ellipse at least in Chrome, for unknown reason */
      border-radius: 100%;
    }
    .no-focus &:focus {
      background: initial;
      border-radius: 0;
    }
    `
    : ""}
`;
//# sourceMappingURL=_base.js.map